import { render, staticRenderFns } from "./DialogEmployee.vue?vue&type=template&id=0036114d"
import script from "./DialogEmployee.vue?vue&type=script&lang=js"
export * from "./DialogEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports